
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("bjmK5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "BackgroundScriptsUnsafe", () => $25774579aff09c6c$export$3272d86409535c78);
$parcel$export(module.exports, "BackgroundScripts", () => $25774579aff09c6c$export$5a06b2ee660255d9);
$parcel$export(module.exports, "default", () => $25774579aff09c6c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7CMCs = parcelRequire("7CMCs");

var $6MtPV = parcelRequire("6MtPV");

var $2RhPB = parcelRequire("2RhPB");

var $dkaZQ = parcelRequire("dkaZQ");

var $lfTZh = parcelRequire("lfTZh");

var $gh1hi = parcelRequire("gh1hi");

var $jsSpF = parcelRequire("jsSpF");

var $h3sy7 = parcelRequire("h3sy7");

var $dvSZ2 = parcelRequire("dvSZ2");
const $25774579aff09c6c$export$3272d86409535c78 = ()=>{
    const { data: forgeData } = (0, $gh1hi.useDashboardForgeResource)();
    const { data: dashboardData } = (0, $gh1hi.useDashboardResource)();
    const analyticsAttributes = (0, $5uXOq.useCallback)(()=>(0, $6MtPV.createAttributes)(), []);
    const dashboardId = dashboardData?.id;
    const backgroundScriptsCombined = (0, $5uXOq.useMemo)(()=>(0, $jsSpF.getScriptsForTheInstalledGadgets)({
            gadgets: dashboardData?.gadgets || [],
            connectBackgroundScripts: dashboardData?.backgroundScripts || [],
            forgeBackgroundScripts: forgeData?.backgroundScripts || []
        }), [
        dashboardData?.gadgets,
        dashboardData?.backgroundScripts,
        forgeData?.backgroundScripts
    ]);
    const hasScripts = backgroundScriptsCombined.length > 0;
    if (false || !hasScripts || dashboardId == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "background-scripts-unsafe",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($25774579aff09c6c$var$Container, null, backgroundScriptsCombined.map((script)=>{
        switch(script.type){
            case 'forge':
                {
                    const module = script.item;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dkaZQ.AnalyticsWrapper), {
                        attributes: {
                            ...(0, $2RhPB.getAnalyticsAttributesFromExtension)(script.item)
                        },
                        key: `${module.id}_${module.properties.resourceUploadId}`
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dvSZ2.ForgeBackgroundScript), {
                        item: module
                    }));
                }
            case 'connect':
                {
                    const { appKey: appKey, moduleKey: moduleKey } = script.item;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h3sy7.ConnectBackgroundScript), {
                        key: `connect-iFrame-${appKey}-${moduleKey}`,
                        id: "connect",
                        packageName: "dashboardBackgroundScript",
                        item: script.item,
                        analytics: analyticsAttributes()
                    });
                }
            default:
                return null;
        }
    })));
};
const $25774579aff09c6c$export$5a06b2ee660255d9 = ()=>{
    const getAttributes = (0, $5uXOq.useCallback)((error)=>(0, $6MtPV.createAttributes)({
            error: error
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "background-scripts",
        packageName: "jiraDashboardBackgroundScripts",
        teamName: "smite",
        fallback: "unmount",
        attributes: getAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($25774579aff09c6c$export$3272d86409535c78, null));
};
var $25774579aff09c6c$export$2e2bcd8739ae039 = $25774579aff09c6c$export$5a06b2ee660255d9;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $25774579aff09c6c$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dkaZQ", function(module, exports) {

$parcel$export(module.exports, "AnalyticsWrapper", () => $290ae18b5c4d09d8$export$63b55d605f8a2340);

var $5uXOq = parcelRequire("5uXOq");

var $k2DRb = parcelRequire("k2DRb");

var $1rTGO = parcelRequire("1rTGO");
const $290ae18b5c4d09d8$export$63b55d605f8a2340 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.DASHBOARD_BACKGROUND_SCRIPT_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });

});

parcelRegister("jsSpF", function(module, exports) {

$parcel$export(module.exports, "getScriptsForTheInstalledGadgets", () => $40de76320b21422c$export$e510c3fd0871c515);

var $e0AC8 = parcelRequire("e0AC8");
const $40de76320b21422c$var$transformConnectItem = ({ iframe: { addonKey: addonKey, moduleKey: moduleKey, options: options } })=>({
        appKey: addonKey,
        moduleKey: moduleKey,
        options: typeof options === 'string' ? JSON.parse(options) : options
    });
const $40de76320b21422c$export$e510c3fd0871c515 = ({ gadgets: gadgets, connectBackgroundScripts: connectBackgroundScripts, forgeBackgroundScripts: forgeBackgroundScripts })=>{
    const forgeApps = new Set();
    const connectApps = new Set();
    gadgets.forEach((item)=>{
        if (item.forge?.key != null) forgeApps.add((0, $e0AC8.getSameEnvAppIdFromExtensionId)(item.forge.key));
        else if (item.connect?.addonKey != null) connectApps.add(item.connect.addonKey);
    });
    return [
        ...forgeBackgroundScripts.map((item)=>({
                type: 'forge',
                item: item
            })),
        ...connectBackgroundScripts.filter((item)=>connectApps.has(item.iframe.addonKey)).map((item)=>({
                type: 'connect',
                item: $40de76320b21422c$var$transformConnectItem(item)
            }))
    ];
};

});

parcelRegister("h3sy7", function(module, exports) {

$parcel$export(module.exports, "ConnectBackgroundScript", () => $464e1b6d16b24d81$export$baa59ce4793896aa);

var $5uXOq = parcelRequire("5uXOq");

var $7V5FW = parcelRequire("7V5FW");

var $hrlU6 = parcelRequire("hrlU6");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $5oFIy = parcelRequire("5oFIy");
var $2NMNM = parcelRequire("2NMNM");

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
var $dnjeJ = parcelRequire("dnjeJ");
const $464e1b6d16b24d81$export$c2649cab647951ba = new (0, $duUGa.UFOExperience)('connect-background-scripts.load-time', {
    type: (0, $atdLB.ExperienceTypes).Load,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom
});
const $464e1b6d16b24d81$export$ab6ba6a7b9f1b2ae = ({ item: item, packageName: packageName, id: id, analytics: analytics })=>{
    const [connectHost, setConnectHost] = (0, $5uXOq.useState)(()=>(0, $hrlU6.getConnectHost)());
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { appKey: appKey, moduleKey: moduleKey, options: options } = item;
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
            appKey: appKey,
            moduleKey: moduleKey,
            ...analytics
        }), [
        analytics,
        appKey,
        moduleKey
    ]);
    (0, $dnjeJ.useUFOComponentExperience)($464e1b6d16b24d81$export$c2649cab647951ba);
    const onLoadingComplete = (0, $5uXOq.useCallback)(()=>{
        $464e1b6d16b24d81$export$c2649cab647951ba.success();
        (0, $8zOmE.fireScreenAnalytics)(createAnalyticsEvent({}), analyticsAttributes);
    }, [
        analyticsAttributes,
        createAnalyticsEvent
    ]);
    const onTimeout = (0, $5uXOq.useCallback)(()=>{
        $464e1b6d16b24d81$export$c2649cab647951ba.abort();
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), `${packageName}.${id} timeout`, analyticsAttributes);
    }, [
        analyticsAttributes,
        createAnalyticsEvent,
        packageName,
        id
    ]);
    (0, $5uXOq.useEffect)(()=>{
        connectHost || (0, $hrlU6.withConnectHost)((host)=>setConnectHost(host)).catch(()=>{
            $464e1b6d16b24d81$export$c2649cab647951ba.failure();
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), `${packageName}.${id} failed`, analyticsAttributes);
        });
    }, [
        connectHost,
        analyticsAttributes,
        createAnalyticsEvent,
        packageName,
        id
    ]);
    if (!connectHost) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7V5FW.EcosystemModuleAsync), {
        appKey: appKey,
        moduleKey: moduleKey,
        options: options,
        appName: `${appKey}-${moduleKey}`,
        location: "dashboardBackgroundScript",
        onLoadingComplete: onLoadingComplete,
        onTimeout: onTimeout
    });
};
const $464e1b6d16b24d81$export$baa59ce4793896aa = ({ id: id, packageName: packageName, item: item, analytics: analytics, ...rest })=>{
    const { appKey: appKey, moduleKey: moduleKey } = item;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        key: `connect-iFrame-${appKey}-${moduleKey}`,
        sourceName: `${packageName}.${id}`,
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
        action: "initialized",
        actionSubject: `${packageName}.${id}`,
        actionSubjectId: `connect-iFrame-${appKey}-${moduleKey}`,
        attributes: {
            appKey: appKey,
            ...analytics
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($464e1b6d16b24d81$export$ab6ba6a7b9f1b2ae, {
        item: item,
        id: id,
        packageName: packageName,
        analytics: analytics
    }));
};

});
parcelRegister("7V5FW", function(module, exports) {

$parcel$export(module.exports, "EcosystemModuleAsync", () => $089ebe0f688adad3$export$75ae776ec6b96bba);
$parcel$export(module.exports, "EcosystemTimeoutViewAsync", () => $089ebe0f688adad3$export$c800b42cc8eabb03);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $089ebe0f688adad3$var$EcosystemModule = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("6d1Z4")), {
    ssr: true,
    moduleId: "./src/packages/connect-utils/connect-utils-async/src/index.tsx"
});

const $089ebe0f688adad3$var$EcosystemTimeoutView = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("kEpYu")), {
    ssr: true,
    moduleId: "./src/packages/connect-utils/connect-utils-async/src/common/ui/ecosystem-timeout-view/index.tsx"
});
const $089ebe0f688adad3$export$75ae776ec6b96bba = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "ecosystem-module-async",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($089ebe0f688adad3$var$EcosystemModule, props));
const $089ebe0f688adad3$export$c800b42cc8eabb03 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "ecosystem-timeout-view-async",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($089ebe0f688adad3$var$EcosystemTimeoutView, props));

});
parcelRegister("6d1Z4", function(module, exports) {

let $48557eef4bcbc98d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $48557eef4bcbc98d$var$load("l49JS").then(()=>parcelRequire('djm2H'));

});

parcelRegister("kEpYu", function(module, exports) {

let $f08bb11ea3c7ed3b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f08bb11ea3c7ed3b$var$load("lFcOl").then(()=>parcelRequire('cXmpj'));

});


// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("dnjeJ", function(module, exports) {

$parcel$export(module.exports, "useUFOComponentExperience", () => $44448c24118cb590$export$30ab340faaed55d4);

var $5uXOq = parcelRequire("5uXOq");
const $44448c24118cb590$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $5uXOq.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $44448c24118cb590$export$30ab340faaed55d4 = (experience)=>{
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            experience.abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $44448c24118cb590$var$useConstructor(()=>experience.start());
    return null;
};

});


parcelRegister("dvSZ2", function(module, exports) {

$parcel$export(module.exports, "ForgeBackgroundScript", () => $f246a8ef00fd3e76$export$e71a867cc455d1dd);

var $5uXOq = parcelRequire("5uXOq");

var $dX22S = parcelRequire("dX22S");
const $f246a8ef00fd3e76$export$e71a867cc455d1dd = ({ item: item })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dX22S.AsyncDashboardBackgroundScript), {
        extension: item,
        extensionData: {}
    });

});
parcelRegister("dX22S", function(module, exports) {

$parcel$export(module.exports, "AsyncDashboardBackgroundScript", () => $863524213094ae3c$export$a49bc38bf8ed3880);

var $5uXOq = parcelRequire("5uXOq");

var $1rTGO = parcelRequire("1rTGO");

var $k2DRb = parcelRequire("k2DRb");

var $3mOWa = parcelRequire("3mOWa");

var $kxZPA = parcelRequire("kxZPA");

var $epSuD = parcelRequire("epSuD");

const $863524213094ae3c$var$getModule = ()=>(parcelRequire("cL9b1"));
const $863524213094ae3c$export$7ef2c8aa7b731b0c = (0, $1rTGO.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $kxZPA.lazyForPaint)(()=>$863524213094ae3c$var$getModule().then((module)=>module.ForgeUIExtension), {
    ssr: false
}));
const $863524213094ae3c$export$a49bc38bf8ed3880 = (props)=>{
    const { extensionData: extensionData, ...restProps } = props;
    const extraProps = {
        module: (0, $k2DRb.DASHBOARD_BACKGROUND_SCRIPT_MODULE),
        extensionData: {
            ...extensionData,
            type: (0, $k2DRb.DASHBOARD_BACKGROUND_SCRIPT_MODULE)
        },
        contextToken: (0, $k2DRb.CONTEXT_TOKEN_TYPE_JIRA)
    };
    if (!(0, $3mOWa.isCustomUIExtension)(props.extension) && !(0, $3mOWa.isNativeUiExtension)(props.extension)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $epSuD.InvisibleDiv), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($863524213094ae3c$export$7ef2c8aa7b731b0c, {
        ...restProps,
        ...extraProps,
        hasModalConsentPrompt: true,
        isIframeHidden: true
    }));
};

});
parcelRegister("epSuD", function(module, exports) {

$parcel$export(module.exports, "InvisibleDiv", () => $e6cc3ab87347b32e$export$22ef238a7bbeac70);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $e6cc3ab87347b32e$export$22ef238a7bbeac70 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e6cc3ab87347b32e$var$StyledInvisibleDiv, null, children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e6cc3ab87347b32e$var$StyledInvisibleDiv = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("cL9b1", function(module, exports) {

let $94a0fe21489f05f8$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $94a0fe21489f05f8$var$load("3yAl4"),
    $94a0fe21489f05f8$var$load("76n7a"),
    $94a0fe21489f05f8$var$load("l253H"),
    $94a0fe21489f05f8$var$load("ffQaD"),
    $94a0fe21489f05f8$var$load("kvRbA"),
    $94a0fe21489f05f8$var$load("kNFvF"),
    $94a0fe21489f05f8$var$load("lG0h2")
]).then(()=>parcelRequire('3twM3'));

});





//# sourceMappingURL=async-jira-dashboard-background-scripts.daa43b70.js.map
